import { useMemo } from 'react';

import { get } from '@lumapps/constants';
import { getSummarizedCustomer } from '@lumapps/customer/ducks/selectors';
import { useInstanceLogo } from '@lumapps/instance/hooks/useInstanceLogo';
import { getNavigationPromise, getParentNavigationPromise } from '@lumapps/navigation/utils/navigationMemStore';
import { useSelector } from '@lumapps/redux/react';
import { useResponsive } from '@lumapps/responsive';
import { wasUserInitialized } from '@lumapps/user/ducks/selectors';

import { getSession } from '../ducks/selectors';
import { Session } from '../types';

const { applicationId } = get();
/**
 * Hook that will retrieve basic information about the application
 */
const useSession = () => {
    const currentSession = useSelector(getSession);
    const wasUserLegacyInitialized = useSelector(wasUserInitialized);
    const device = useResponsive();
    const instanceLogo = useInstanceLogo();
    const { instance } = currentSession;
    const organization = useSelector(getSummarizedCustomer);
    /**
     * When we are on the legacy app, we need to wait for the user to be initialized.
     * On the new apps, we don't need to wait.
     */
    const user: Session['user'] =
        applicationId !== 'legacy' || wasUserLegacyInitialized ? currentSession.user : undefined;

    const session = useMemo(() => {
        return {
            ...currentSession,
            instance: {
                ...instance,
                logo: instanceLogo,
            },
            user,
            device,
            organization,
            navigations: {
                getCurrent: getNavigationPromise,
                getParent: instance?.parent ? getParentNavigationPromise : null,
            },
        };
    }, [currentSession, device, instance, instanceLogo, organization, user]);

    return session;
};

export { useSession };
